module.exports = __webpack_public_path__ + "static/media/events_title.e24c1b3c.png";